import { apiGet, apiPut } from './apiClient';

export const siteSettingsService = {
  getSettings: async () => apiGet('site-settings'),
  updateSettings: async (data) => apiPut('site-settings', data),
};
